<template>
  <tr class="single-item">
    <td data-title="商品">
      <div class="product-content one-detail">
        <div class="product-content__img">
          <img :src="item.photo" alt="" />
        </div>
        <div class="product-content__text">
          <div class="product-content__text-name">
            <span :title="item.name" class="name">
              {{ item.name }}
            </span>
          </div>
          <div class="product-content__text-discount">
            {{ item.combination }}
          </div>
        </div>
      </div>
    </td>
    <!-- //TODO: currency format -->
    <td data-title="單價">${{ item.price }}</td>
    <td data-title="數量">x{{ item.count }}</td>
    <td data-title="優惠" class="discount">
      {{ discountTypeName }}
      <span v-if="item.discount_name">{{ item.discount_name }}</span>
    </td>
    <td data-title="價格" class="total-price">$ {{ item.subtotal || 0 }}</td>
    <td data-title="刪除" class="delete">
      <span
        v-if="item.discount_name"
        class="icon-icon_delete2"
        @click="removeOrderDiscount"
      ></span>
      <span v-else class="icon-icon_delete2" @click="removeItem"></span>
    </td>
  </tr>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  props: {
    item: {
      required: true,
      type: Object
    }
  },
  data() {
    return {};
  },
  computed: {
    discountTypeName() {
      // 優惠內容類型 1:贈品 2:折扣 3:折價 4:會員等級折扣 5:促銷組合
      let name = null;

      if (this.item.discount_type == 1) {
        name = '贈品';
      }

      if (this.item.discount_type == 2) {
        name = '折扣';
      }

      if (this.item.discount_type == 3) {
        name = '折價';
      }

      if (this.item.discount_type == 4) {
        name = '會員等級折扣';
      }

      if (this.item.discount_type == 5) {
        name = '促銷組合';
      }

      return name;
    }
  },
  methods: {
    ...mapActions('order', [
      'removeProgram',
      'removeProduct',
      'updateOrderDiscount'
    ]),
    removeItem() {
      if (this.item.type === 'product') {
        this.removeProduct({
          productId: this.item.product_id,
          productIndex: this.item.index
        });
      } else if (this.item.type === 'program') {
        this.removeProgram(this.item.index);
      }
    },
    removeOrderDiscount() {
      this.updateOrderDiscount({
        type: this.item.discount_en_name,
        addProducts: [],
        removeProductIds: [this.item.product_spec.product_spec_id]
      });
    }
  }
};
</script>
